import { createPageDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';

export const creditBalanceDTOSchema = z.object({
  balance: z.number().int(),
  purchasedTotal: z.number().int(),
  consumedTotal: z.number().int(),
  asOf: z.string(),
});

export const creditBurnRateDTOSchema = z.object({
  creditsPerDay: z.number().int(),
  sevenDayProjectedUsage: z.number().int(),
  projectedDepletionDate: z.string().nullable(),
  daysRemaining: z.number().int().nullable(),
});

export const creditOperationDTOSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  amount: z.number().int(),
  operationType: z.string().nullable(),
  description: z.string().nullable(),
  actorUserId: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()),
});

export const creditOperationsPageDTOSchema = createPageDTOSchema(creditOperationDTOSchema);

export const LOW_BALANCE_THRESHOLD_RATIO = 0.2;

export const isBalanceLow = (balance: number, purchasedTotal: number): boolean =>
  purchasedTotal > 0 && balance / purchasedTotal <= LOW_BALANCE_THRESHOLD_RATIO;
